// extracted by extract-css-chunks-webpack-plugin
module.exports = {"trigger":"A85cna","trigger-with-background":"_37EHR0"};